import React from "react";
import styled, { ThemeConsumer } from "styled-components";

const LogoView = styled.div`
  position: relative;
  top: 1px;
  display: inline-block;
  vertical-align: middle;
  width: 83px;
  height: 47px;
  margin-right: 20px;
  margin-left: 3px;
  color: #fff;
`;

const Logo = () => (
  <LogoView>
    <ThemeConsumer>{theme => theme.logo}</ThemeConsumer>
  </LogoView>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/TradeHeader/Logo.js